import {memo} from 'react';

import type {SVGProps} from 'react';

export const SollapayLogoIllustration = memo(function SollapayLogoIllustration(
  props: SVGProps<SVGSVGElement>
) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="15.62 32.88 223.88 47.63"
      fill="none"
      {...props}
    >
      <path
        fill="currentColor"
        d="M162.09,66.59c-4.72,0-8.54-4.3-8.54-9.6s3.82-9.61,8.54-9.61,8.54,4.3,8.54,9.61-3.82,9.6-8.54,9.6M163.28,40.96c-3.5,0-6.71,1.34-9.24,3.56v-3h-7.31v38.94h7.31v-10.98c2.53,2.22,5.74,3.56,9.24,3.56,8.13,0,14.72-7.18,14.72-16.04s-6.59-16.04-14.72-16.04"
      />
      <path
        fill="currentColor"
        d="M128.39,66.59c-4.72,0-8.54-4.3-8.54-9.6s3.82-9.61,8.54-9.61,8.54,4.3,8.54,9.61-3.82,9.6-8.54,9.6M136.43,44.52c-2.53-2.22-5.74-3.56-9.24-3.56-8.13,0-14.72,7.18-14.72,16.04s6.59,16.04,14.72,16.04c3.5,0,6.71-1.34,9.24-3.56v2.91h7.31v-30.87h-7.31v3Z"
      />
      <path
        fill="currentColor"
        d="M195.66,66.59c-4.72,0-8.54-4.3-8.54-9.6s3.82-9.61,8.54-9.61,8.54,4.3,8.54,9.61-3.82,9.6-8.54,9.6M203.7,44.52c-2.53-2.22-5.74-3.56-9.24-3.56-8.13,0-14.72,7.18-14.72,16.04s6.59,16.04,14.72,16.04c3.5,0,6.71-1.34,9.24-3.56v2.91h7.31v-30.87h-7.31v3Z"
      />
      <path
        fill="currentColor"
        d="M108.86,62.23v-29.11h-7.31v29.07c0,5.77,4.68,10.44,10.44,10.44h.49v-6.84h-.06c-1.97,0-3.56-1.59-3.56-3.56"
      />
      <path
        fill="currentColor"
        d="M96.3,62.23v-29.11h-7.31v29.07c0,5.77,4.67,10.44,10.44,10.44h.49v-6.84h-.06c-1.97,0-3.56-1.59-3.56-3.56"
      />
      <path
        fill="currentColor"
        d="M232.86,41.52l-6.18,19.5h-.29l-6.15-19.5h-6.98v.96l9.76,27.79-1.52,4.25h-7.35v5.99h7.62c3.42,0,4.97-1.39,5.8-3.88l11.93-34.15v-.96h-6.63Z"
      />
      <path
        fill="currentColor"
        d="M71.2,65.89c-4.92,0-8.91-3.99-8.91-8.91s3.99-8.91,8.91-8.91,8.91,3.99,8.91,8.91-3.99,8.91-8.91,8.91M71.2,40.94c-8.86,0-16.04,7.18-16.04,16.04s7.18,16.04,16.04,16.04,16.04-7.18,16.04-16.04-7.18-16.04-16.04-16.04"
      />
      <path
        fill="currentColor"
        d="M47.67,48.9c-2.03-1.12-4.14-1.52-6.12-1.79l-15.77-2.16c-.78-.11-1.48-.68-1.73-1.44-.26-.79-.11-1.69.41-2.41.49-.68,1.23-1.07,2.02-1.07l26.26-.02v-7.12s-25.79-.01-25.79-.01h0c-3.28,0-6.22,1.42-8.09,3.89-2.06,2.73-2.59,6.2-1.41,9.28,1.19,3.11,3.95,5.41,7.05,5.84l16.42,2.3c3.29.46,5.26,1.74,5.85,3.8.89,3.07-.59,6.22-3.52,7.47-1.74.74-3.64.86-5.35.32-3.15-.99-6.55-4.56-8.52-7.66-1.86-2.92-4.98-4.25-8.16-3.48-3.22.79-5.56,3.68-5.57,6.88l-.03,11.4,7.08.02v-11.19c.02-.06.11-.19.18-.23.1,0,.26.06.34.18,2.92,4.35,7.65,9.82,13.57,11.14,1.1.24,2.21.37,3.32.37,1.62,0,3.24-.26,4.8-.78,6.59-2.19,10.4-8.92,8.86-15.66-.76-3.33-2.92-6.12-6.09-7.86"
      />
    </svg>
  );
});
